import React from 'react';
import { useTranslation } from 'react-i18next';
import { CameraOutlined } from '@ant-design/icons';

/**
 * 连拍按钮组件
 */
interface PhotoAddCaptureViewProps {
    onNativeBurstCapture: () => void; // 原生连拍回调
}

const PhotoAddCaptureView: React.FC<PhotoAddCaptureViewProps> = ({
    onNativeBurstCapture
}) => {
    const { t } = useTranslation();

    const handleClick = () => {
        onNativeBurstCapture();
    };

    return (
        <div
            className="aspect-square overflow-hidden bg-white w-full border border-gray-200 rounded-lg flex items-center justify-center cursor-pointer"
            onClick={handleClick}
        >
            <div className="flex flex-col items-center cursor-pointer p-2">
                <div className="text-5xl text-gray-400 mb-2">
                    <CameraOutlined />
                </div>
            </div>
        </div>
    );
};

export default PhotoAddCaptureView;
